module.exports = __webpack_public_path__ + "assets/img/_Novo Show Unit_PD Door_RGB_lr.150c6348.jpg";